import Env from '@/common/constants/Env.json';
import EnvStage from '@/common/constants/Env_stage.json';
import EnvProd from '@/common/constants/Env_prod.json';

let CODE_ENV_LIST = Env;

if (process.env.NODE_ENV === 'production') {
  CODE_ENV_LIST = EnvProd;
} else if (process.env.VUE_APP_MODE === 'stage') {
  CODE_ENV_LIST = EnvStage;
}

export const BASE_CODE_TYPE = {
  ACTIVE: { name: '정상', value: 'ACTIVE' },
  DELETE: { name: '삭제', value: 'DELETE' }
};

export const StudyStatus = {
  ACTIVE: { name: '진행중', value: 'ACTIVE' },
  STOP: { name: '중지', value: 'STOP' },
  DONE: { name: '수강완료', value: 'DONE' }
};

export const AuthType = {
  MODIFY: { name: '수정', value: 'MODIFY' },
  FIND: { name: '찾기', value: 'FIND' }
};

export const MoveType = {
  MOVE: { name: 'MOVE', value: 'MOVE' },
  LINK: { name: 'LINK', value: 'LINK' }
};

export const BoardType = {
  NOTICE: { name: '공지사항', value: 'NOTICE' },
  FAQ: { name: 'FAQ', value: 'FAQ' }
};

export const PushState = {
  NOT_SEND: { name: 'NOT_SEND', value: 'NOT_SEND' },
  SEND: { name: 'SEND', value: 'SEND' }
};

const ConstCode = function() {
  return {
    CODE_ENV_LIST,
    StudyStatus,
    BoardType,
    PushState,
    AuthType,
    MoveType,
    BASE_CODE_TYPE,
    getFilePath: function(path = '') {
      return `${this.CODE_ENV_LIST.FILE_SERVER_URL}${path}`;
    },
    getImagePath: (path = '', resolution = 'origin') => {
      return `${CODE_ENV_LIST.FILE_SERVER_URL}/${resolution}/${path}`;
    }
  };
};

export default ConstCode();
